// Switch from VITE_* to VITE_* naming (Vite exposes only VITE_ prefixed vars).
// Ensure you define these in your .env / deployment environment:
// VITE_FIREBASE_API_KEY, VITE_FIREBASE_AUTH_DOMAIN, VITE_FIREBASE_PROJECT_ID,
// VITE_FIREBASE_STORAGE_BUCKET, VITE_FIREBASE_MESSAGING_SENDER_ID, VITE_FIREBASE_APP_ID
const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Quick validation to help detect misconfiguration early in development.
for (const [k, v] of Object.entries(config)) {
  if (!v) {
    console.error(`[firebase/config] Missing env var for ${k}.`);
  }
}

// When deployed, there are quotes that need to be stripped
for (const key of Object.keys(config)) {
  const configValue = `${config[key]}`;
  if (configValue.charAt(0) === '"') {
    config[key] = configValue.substring(1, configValue.length - 1);
  }
}

export const firebaseConfig = config;
